import { abi as __ChumbiVestingABI } from "../contracts/ChumbiVesting.json";
import { abi as _ChumbiABI } from "../contracts/ChumbiToken.json";

export const ChumbiVestingABI = __ChumbiVestingABI;
export const ChumbiVestingAddress =
  "0xAD190C1924D625E6a5d8620918f856Cbc1515523";
export const ChumbiABI = _ChumbiABI;
export const ChumbiAddress = "0x59A1e03a44d7e9b1CCd18CFC282b5ACFb720c979";
